import type { MouseEvent } from 'react';
import { cx } from '@/lib/cx';
import { Icon, type IconName } from './Icon';
import s from './Notch.module.css';

export type NotchAction = { icon: IconName; label: string; onClick?: () => void };

/**
 * The Notch: a cutout at the card's top-right with 1–2 round 40px icon buttons
 * (54px wide for one, 100px for two, 52px tall). The parent card must be position:relative.
 */
export function Notch({ actions, className }: { actions: NotchAction[]; className?: string }) {
  return (
    <div className={cx(s.notch, actions.length > 1 ? s.two : s.one, className)}>
      <div className={s.fill} />
      <div className={s.cornerLeft} />
      <div className={s.cornerBottom} />
      <div className={s.buttons}>
        {actions.map((a) => (
          <button
            key={a.icon}
            type="button"
            className={s.btn}
            title={a.label}
            aria-label={a.label}
            onClick={(e: MouseEvent) => {
              e.stopPropagation();
              a.onClick?.();
            }}
          >
            <Icon name={a.icon} size={17} height={17} />
          </button>
        ))}
      </div>
    </div>
  );
}
